import React, { useState } from 'react'
import Drawer from '../shared/Drawer'

export default function AffiliateLinksDrawer({ affiliateCode, closeDrawer }) {
  const [copiedUrl, setCopiedUrl] = useState(null)
  const affiliateLinks = affiliateCode?.affiliateLinks || []

  const copyLink = url => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url)
    } else {
      const input = document.createElement('input')
      input.value = url
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
    }

    setCopiedUrl(url)
  }

  return (
    <Drawer
      visible={ !!affiliateCode }
      closeDrawer={ closeDrawer }
      title={ Partners.translations.affiliateCode.affiliate_links }
      subtitle={ Partners.translations.affiliateCode.affiliate_links_subtitle }
    >
      <div className='flex-box flex-column flex-1'>
        <div className='flex-box flex-column' style={{ gap: 12 }}>
          { affiliateLinks.map(link => (
            <div
              key={ link.flavour }
              className='flex-box items-end content-space-between'
              style={{ gap: 12, padding: 12 }}
            >
              <div className='flex-box flex-column' style={{ flex: 1, minWidth: 0 }}>
                <div className='bold m-b-5'>
                  { link.label }
                </div>
                <input
                  type='text'
                  value={ link.url }
                  readOnly
                  style={{ width: '100%' }}
                />
              </div>

              <button
                type='button'
                className='btn'
                onClick={ () => copyLink(link.url) }
                title={ Partners.translations.affiliateCode.copy_link }
              >
                <i className={ `fa-light ${ copiedUrl === link.url ? 'fa-check' : 'fa-copy' }` } />
              </button>
            </div>
          ))}

          { affiliateLinks.length === 0 &&
            <div>
              { Partners.translations.affiliateCode.no_affiliate_links }
            </div>
          }
        </div>
      </div>
    </Drawer>
  )
}
